import { render, staticRenderFns } from "./FailedStatus.vue?vue&type=template&id=c0c79546"
import script from "./FailedStatus.vue?vue&type=script&lang=js"
export * from "./FailedStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports